<template>
  <div :class="getLoading ? 'bg-white' : ''" class="flex-auto py-6 pt-0">
    <div
      v-if="getLoading"
      class="bg-white w-full flex flex-col py-10 justify-center items-center"
    >
      <!-- https://gannon.tv/intro -->
      <img width="260" src="@/assets/imgs/loading.gif" alt="loading" />
      <h3>Loading...</h3>
    </div>
    <form v-if="!getLoading">
      <div class="flex justify-between items-center pr-4">
        <h6
          class="pl-4 text-blueGray-400 text-sm mt-4 mb-6 font-bold uppercase"
        >
          Basic
        </h6>
        <button
          @click="handleAddHotspot"
          type="button"
          class="bg-gray-500 text-white active:bg-gray-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
        >
          Add Hotspot
        </button>
      </div>
      <div class="flex flex-wrap">
        <div
          v-for="(value, name) in slideAttrbutes"
          :key="name"
          class="w-full lg:w-6/12 px-4"
        >
          <div class="relative w-full mb-3">
            <label
              class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
            >
              <AttrTitleWithDescription
                :title="name"
                :description="value.description"
              />
            </label>
            <input
              v-model="formDataLocal[`${name}`]"
              type="text"
              class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
            />
          </div>
        </div>
        <div class="w-full lg:w-12/12 px-4">
          <div class="relative w-full mb-3">
            <ImagePreview
              :formData="formData"
              :index="String(index)"
              :dotSize="44"
              :imageSize="900"
              @update:formData="handleUpdateHotspot"
            />
          </div>
        </div>
      </div>
      <HotspotPanel
        v-for="(hotspot, index) in formDataLocal['hotspots']"
        :hotspotId="index"
        :key="index"
        :allSlideAttributes="allSlideAttrbutes"
        :formData="formData"
        @update:formData="handleUpdateHotspot"
      />
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import HotspotPanel from "@/components/ComponentModule/ImageSlideComponent/HotspotPanel";
import AttrTitleWithDescription from "@/components/Shared/Headers/AttrTitleWithDescription";
import ImagePreview from "@/components/Shared/Input/ImagePreview";

export default {
  name: "ImageSlideUpdateForm",
  components: { HotspotPanel, ImagePreview, AttrTitleWithDescription },
  props: {
    formData: {
      type: Object,
      required: true
    },
    instanceId: {
      type: [Number, String],
      required: true
    },
    index: {
      type: String,
      required: false
    },
    instanceData: {
      type: Object,
      required: true
    },
    allSlideAttrbutes: {
      type: Object,
      required: false
    }
  },
  mounted() {
    if (Object.keys(this.slideInstance).length) {
      Object.keys(this.slideInstance.attributes).forEach((item) => {
        if (item !== "hotspots") {
          this.formDataLocal[item] = this.slideInstance.attributes[item];
        }
      });
    }
    if (this.hotspots) {
      if (typeof this.hotspots === "string") {
        this.formDataLocal["hotspots"] = JSON.parse(this.hotspots);
      } else {
        this.formDataLocal["hotspots"] = this.hotspots;
      }
    }
  },
  computed: {
    hotspots() {
      if (this.slideInstance.attributes) {
        return this.slideInstance.attributes.hotspots;
      }
      return {};
    },
    slideAttrbutes() {
      if (this.allSlideAttrbutes) {
        let { hotspots, ...params } = this.allSlideAttrbutes;// eslint-disable-line
        return params;
      }
      return {};
    },
    slideInstance() {
      if (
        this.instanceData.length &&
        this.instanceData.find(
          (item) => parseInt(item.id) === parseInt(this.instanceId)
        )
      ) {
        return this.instanceData.find(
          (item) => parseInt(item.id) === parseInt(this.instanceId)
        );
      } else {
        return {};
      }
    },
    formDataLocal: {
      get: function () {
        return this.formData;
      },
      set: function (val) {
        this.$emit("update:formData", val);
      }
    },
    ...mapGetters(["getLoading"])
  },
  watch: {
    slideInstance() {
      if (Object.keys(this.slideInstance).length) {
        Object.keys(this.slideInstance.attributes).forEach((item) => {
          if (item !== "hotspots") {
            this.formDataLocal[item] = this.slideInstance.attributes[item];
          }
        });
      }
    },
    // auto fix hotspots structure
    hotspots() {
      if (this.hotspots) {
        if (typeof this.hotspots === "string") {
          this.formDataLocal["hotspots"] = JSON.parse(this.hotspots);
        } else {
          this.formDataLocal["hotspots"] = this.hotspots;
        }
      }
    }
  },
  methods: {
    handleUpdateHotspot(val) {
      this.formDataLocal["attributes"] = val;
    },
    handleAddHotspot() {
      this.formDataLocal["hotspots"].push({
        pos_left: 0,
        pos_top: 0
      });
    }
  }
};
</script>
